import instance from "../../api/Api";

/**
 * Gets a list of available plans, sorted by title
 * @returns {Promise<Array<object>>} a list of plan objects
 */
export const getPlans = async () => {
  const { data } = await instance.get("/v1/account/plans/");

  return [...data].sort((a, b) => a.title.localeCompare(b.title));
};

/**
 * Checks if the user has an active plan
 * @returns {Promise<boolean>} whether the user has an active plan
 */
export const userHaveActivePlan = async () => {
  const { data } = await instance.get("/v1/account/has-active-plan/");
  return data;
};

/**
 * Retrieves a list of pages that the user has permission to access.
 *
 * @returns {Promise<Array<string>>} a list of page keys that the user can access
 */
export const getUserPageAccess = async () => {
  const { data } = await instance.get("/v1/common/user-accessible-pages/");
  return data;
};
